import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ContractType, SharedFileDto, SharedFileHeaderDto, SharedFilesHttpService } from 'app/api';
import { openFileLink } from 'app/helpers/file-link.helper';
import { OrganizationService, SentryService, ToastService, WhiteLabelClientSettingsService } from 'app/services';
import { Agreement } from '../../../models/agreement';

@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss'],
    standalone: false
})
export class ContractsComponent implements OnInit {
	@Input() contracts: SharedFileDto[];
	@Input() agreements?: Agreement[];
	partnerKey: string;

	ContractType = ContractType;
	contractLoading: Record<string, boolean> = {};

	constructor(
		private translateService: TranslateService,
		private organizationService: OrganizationService,
		private sharedFilesService: SharedFilesHttpService,
		private toastService: ToastService,
		private sentryService: SentryService,
		private clientSettingsService: WhiteLabelClientSettingsService
	) {}

	ngOnInit(): void {
		this.partnerKey = this.clientSettingsService.getSettings()?.key ?? null;
	}

	isContractLoading(id) {
		return this.contractLoading[id];
	}

	getContract(fileId) {
		if (this.contractLoading[fileId]) {
			return;
		}
		this.contractLoading[fileId] = true;
		const organizationId = this.organizationService.getOrganizationId();
		const creditId = this.organizationService.getCreditId();
		this.sharedFilesService.getSharedFileForOrganizationAndCredit(organizationId, creditId, fileId).subscribe(
			file => {
				this.contractLoading[fileId] = false;
				this.sentryService.addBreadcrumb('Contract URL fetched', 'files', {
					fileUrl: file.url,
				});
				this.sentryService.setTag('partner_key', this.partnerKey);
				this.sentryService.addComponentName('ContractsComponent');
				this.sentryService.captureMessage('File URL fetched');
				openFileLink(file.url, this.partnerKey);
			},
			error => {
				this.sentryService.addHttpResponseMessage(error.message);
				this.sentryService.captureMessage('Download contract error triggered', 'error');
				this.toastService.error('home.toast.download-contract.error');
				this.contractLoading[fileId] = false;
			}
		);
	}

	openAgreement(link: string) {
		window.open(link);
	}

	getContractTitle(contract: SharedFileHeaderDto): string {
		return (
			contract.properties?.ContractTitle ||
			contract.name ||
			this.translateService.instant('home.contracts.type.placeholder')
		);
	}
}
